var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M0 8C0 3.58172 3.58172 0 8 0C12.4182 0 16 3.58172 16 8C16 12.4182 12.4182 16 8 16C3.58172 16 0 12.4182 0 8ZM8 1.6C4.46538 1.6 1.6 4.46538 1.6 8C1.6 11.5346 4.46538 14.4 8 14.4C11.5346 14.4 14.4 11.5346 14.4 8C14.4 4.46538 11.5346 1.6 8 1.6Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8.00026 3.19995C8.4421 3.19995 8.80026 3.55813 8.80026 3.99995V7.14363C8.80026 7.36787 8.80106 7.48179 8.80866 7.56307L8.80906 7.56715L8.81218 7.56971C8.87562 7.62107 8.96994 7.68491 9.1565 7.80931L10.844 8.93427C11.2116 9.17939 11.311 9.67611 11.0659 10.0437C10.8208 10.4113 10.3241 10.5107 9.9565 10.2656L8.26898 9.14059C8.26162 9.13571 8.25434 9.13083 8.24698 9.12595C8.0917 9.02243 7.93346 8.91699 7.8049 8.81283C7.65738 8.69331 7.50458 8.54163 7.38962 8.32675C7.27458 8.11195 7.23314 7.90059 7.21554 7.71163C7.20018 7.54683 7.20026 7.35667 7.20026 7.17011C7.20026 7.16131 7.20026 7.15243 7.20026 7.14363V3.99995C7.20026 3.55813 7.55842 3.19995 8.00026 3.19995Z",
          fill: "black",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }